import logger from '../../../Utils/logger';
import React, { useEffect, useRef, useState } from 'react';
import '.././PopupCommonStyle.css';
import styles from './Style.module.css';
import { BtnPrimary } from '../../Buttons/BtnPrimary';
import { BtnSecondary } from '../../Buttons/BtnSecondary';
import { useNavigate, useLocation as useRouterLocation } from 'react-router-dom';
import { useUI } from '../../../Context/UI/UIContext';
import { useBookingSession } from '../../../Context/BookingSession/BookingSessionContext';
import { useAppointment } from '../../../Context/Appointment/AppointmentContext';
import { useGuests } from '../../../Context/Guests/GuestsContext';
import { useLocation } from '../../../Context/Location/LocationContext';
import { useVoucherContext } from '../../../Context/Voucher/VoucherContext';
import { releaseBookingHoldOnce } from '../../../Utils/bookingHold';
import { clearSessionStorage } from '../../../Utils/SessionStorage';
import { useSchedule } from '../../../Context/Schedule/ScheduleContext';
import { useBookingTimer } from '../../../Context/Timer/useBookingTimer';
import { useCustomer } from '../../../Context/Customer/CustomerContext';
// import { BtnClose } from '../../Buttons/BtnClose/BtnClose';

const VOUCHER_ROUTES = ["/select-vouchers", "/billing-details", "/review-voucher-purchase"];
const OVERLAY_CLASSES = ['overlay', 'overflow-hidden', 'overlay-index'];

export const ExitCard = () => {
  const { isExitCardActive, setIsExitCardActive } = useUI();
  const { setBookingID, uuid } = useBookingSession();
  const { setSelectedDate, setSelectedTime } = useSchedule();
  const { setAppointmentTypeID } = useAppointment();
  const { resetMembers, setPrimaryCustomer, selectedServices = [] } = useGuests();
  const { setSelectedOutletID } = useLocation();
  const { resetTimer } = useBookingTimer();
  const { clearVoucherCart } = useVoucherContext();
  const { setFormData, setIsUserVerified, setUserID } = useCustomer();
  const [isExiting, setIsExiting] = useState(false);
  const isExitingRef = useRef(false);

  const addonCount = selectedServices.reduce((total, service) => total + (service.selectedAddons?.length || 0), 0);
  const therapistCount = new Set(selectedServices
    .map((service) => service.therapistData?.id ?? service.therapistData?.therapist_id)
    .filter((id) => id != null)
    .map(String)).size;
  const selectionLabels = [
    [selectedServices.length, 'service', 'services'],
    [addonCount, 'add-on', 'add-ons'],
    [therapistCount, 'therapist', 'therapists'],
  ].filter(([count]) => count > 0)
    .map(([count, singular, plural]) => count === 1 ? singular : plural);
  const selectionLabel = selectionLabels.length > 1
    ? `${selectionLabels.slice(0, -1).join(', ')} and ${selectionLabels[selectionLabels.length - 1]}`
    : selectionLabels[0];
  const selectionMessage = selectionLabel
    ? `Your selected ${selectionLabel} will be lost.`
    : 'Your selections will be lost.';

  const handleClose = () => {
    setIsExitCardActive(false);
  };

  useEffect(() => {
    if (isExitCardActive) {
      document.body.classList.add(...OVERLAY_CLASSES);
    } else {
      document.body.classList.remove(...OVERLAY_CLASSES);
      isExitingRef.current = false;
      setIsExiting(false);
    }

    return () => {
      document.body.classList.remove(...OVERLAY_CLASSES);
    };
  }, [isExitCardActive]);

  
  const navigate = useNavigate();
  const { pathname } = useRouterLocation();
  const isVoucherRoute = VOUCHER_ROUTES.includes(pathname);

  const handleExit = async () => {
    if (isExitingRef.current) return;
    isExitingRef.current = true;
    setIsExiting(true);
    logger.log('Exit button clicked', uuid);

    if (isVoucherRoute) {
      leaveVoucherFlow();
      return;
    }

    if (uuid) {
      try {
        const response = await releaseBookingHoldOnce(uuid);
        if (response?.data?.success) {
          performCleanupAndNavigate();
        } else {
          logger.error('Booking delete failed:', response);
          isExitingRef.current = false;
          setIsExiting(false);
        }
      } catch (error) {
        // A missing booking is already released, so it must not block leaving.
        if (error?.response?.status === 404) {
          // setUuid(null);
          performCleanupAndNavigate();
          return;
        }
        logger.error('Error deleting booking:', error);
        isExitingRef.current = false;
        setIsExiting(false);
      }
    } else {
      performCleanupAndNavigate();
    }
  };

  const performCleanupAndNavigate = () => {
    clearSessionStorage({ preserveUuid: true });
    setIsExitCardActive(false);
    setAppointmentTypeID(null);
    resetMembers();
    setPrimaryCustomer(null);
    setSelectedOutletID(null);
    setBookingID(null);
    setSelectedTime('');
    setSelectedDate('');
    resetTimer();
    setFormData({
      fname: '',
      lname: '',
      email: '',
      mobile: '',
      countryId: '',
      notes: '',
    });
    setIsUserVerified(false);
    setUserID(null);
    navigate('/');
  };

  const leaveVoucherFlow = () => {
    clearVoucherCart();
    setIsExitCardActive(false);
    navigate('/');
  };

  if(isVoucherRoute){
    return (
      <div className={`${styles.exitCard} popup ${isExitCardActive ? "show" : ""}`}>
      <div className={`${styles.popHeader} popup-header`}>
        <div className={styles.headerContent}>
          <div className={styles.headerText}>
            <h2 className="title">Warning !</h2>
            <h6 className="titleSub">Are you sure you want to cancel and exit purchase?</h6>
            {/* <BtnClose 
            handleClick={handleClose} 
            title="Close" 
            customClass="closeBtn"
            /> */}
          </div>
        </div>
      </div>
      <div className={`${styles.ecFooter} popup-footer`}>
          <BtnSecondary label="Yes, Exit" handleClick={handleExit} disabled={isExiting} customClass="w-100 no-icon"/>
          <BtnPrimary label="Continue Checkout" handleClick={handleClose} customClass="w-100 no-icon"/>
      </div>
    </div>
    )
  } 
  return (
    <div className={`${styles.exitCard} popup ${isExitCardActive ? "show" : ""}`}>
      <div className={`${styles.popHeader} popup-header`}>
        <h2 className="title">Are you sure you want to leave this page?</h2>
        {/* <h6 className="titleSub">All selections will be lost</h6> */}
        <h6 className="titleSub">{selectionMessage}</h6>
        {/* <BtnClose 
        handleClick={handleClose} 
        title="Close" 
        customClass="closeBtn"
        /> */}
      </div>
      <div className={`${styles.ecFooter} popup-footer`}>
          <BtnSecondary label="Yes, leave" handleClick={handleExit} disabled={isExiting} customClass="w-100 no-icon"/>
          <BtnPrimary label="Continue Booking" handleClick={handleClose} customClass="w-100 no-icon"/>
      </div>
    </div>
  )
}
